import { createFileRoute } from "@tanstack/react-router";

import { HubPage } from "@/components/hub-page";

const TITLE = "Science — Research, Labs & Inventions | Luiza Jesus do Prado";
const DESC =
  "Art and science by Luiza Jesus do Prado: research in mental health and neuroscience, the patented Medusa apparatus and interactive labs.";

export const Route = createFileRoute("/science")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.luizajesusdoprado.com/science" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: SciencePage,
});

function SciencePage() {
  return (
    <HubPage
      kicker="Research · Labs · Inventions"
      title="Science"
      intro="Research between the studio and the laboratory: mental health, perception, memory and public health, with devices, instruments and interactive tools."
      works={["what-is-madness", "the-weight-of-feeling", "ecologies-of-perception", "camara-obscura", "neurotransition", "symbiogenesis", "body-sound"]}
      sections={[
        {
          title: "Interactive labs",
          links: [
            { label: "Allostatic Load", href: "/lab/carga" },
            { label: "Observatory", href: "/lab/observatorio" },
            { label: "Mandala of the Unconscious", href: "/lab/mandala" },
            { label: "Nebulae", href: "/lab/nebulosas" },
            { label: "Map of care", href: "/lab/cuidado" },
            { label: "Catalysing Affect", href: "/lab/afeto" },
            { label: "Stereogram generator", href: "/lab/estereograma" },
            { label: "Ecologies of Perception", href: "/lab/ecologias" },
          ],
        },
        {
          title: "Research",
          links: [
            { label: "Art, Science & Technology", href: "/themes/art-science-technology" },
            { label: "Decolonization & Mental Health", href: "/themes/decolonization-mental-health" },
            { label: "Curriculum — formation, patents, certifications", href: "/cv" },
            { label: "LinkedIn", meta: "↗", href: "https://www.linkedin.com/in/luizajesusdoprado" },
          ],
        },
      ]}
    />
  );
}
